import Com from "components/styledComp/CommStyledComp";
import React from "react";

const SaaSOperation = () => {
  return (
    <Com.DivDetailSection>
      <Com.DivDetailHeading>
        <Com.DetailHeading>운영·배포 역량</Com.DetailHeading>
      </Com.DivDetailHeading>
      <div className="strategy-list">
        <div className="strategy">
          <Com.SpanStrategy>1</Com.SpanStrategy>
          <div className="strategy-title">
            <Com.StrongStrategy>지속적 배포·자동 업데이트</Com.StrongStrategy>
            <p className="strategy-desc">
              고객사별 서버 업그레이드 없이 클라우드에서 기능·보안 패치 지속 반영
            </p>
          </div>
        </div>
        <div className="strategy">
          <Com.SpanStrategy>2</Com.SpanStrategy>
          <div className="strategy-title">
            <Com.StrongStrategy>통합 관제·관측성</Com.StrongStrategy>
            <p className="strategy-desc">
              서비스 상태·장애·성능 모니터링 및 이슈 발생 시 신속 대응 체계 구축
            </p>
          </div>
        </div>
        <div className="strategy">
          <Com.SpanStrategy>3</Com.SpanStrategy>
          <div className="strategy-title">
            <Com.StrongStrategy>도입·확장 속도</Com.StrongStrategy>
            <p className="strategy-desc">
              초기 인프라 구축 없이 빠른 개시, 사용량 증가 시 유연한 확장 지원
            </p>
          </div>
        </div>
      </div>
    </Com.DivDetailSection>
  );
};

export default SaaSOperation;
